"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BASE_STAGE = exports.BASE_PROD = exports.KEY_STAGE = exports.KEY_PROD = void 0;
exports.KEY_PROD = "90605579-f9e3-4137-9145-ebf9617a35d7";
exports.KEY_STAGE = "aaa2c924-3cfa-4caf-92f5-b5ccca8d29f0";
exports.BASE_PROD = "https://global.transak.com";
exports.BASE_STAGE = "https://global-stg.transak.com";
//# sourceMappingURL=constants.js.map